/** @format — Sort dropdown with Sort By + Order sections */

import FilterDropdown from "@/components/filters/FilterDropdown";
import FilterMenuItem, { FilterMenuDivider, FilterMenuLabel } from "@/components/filters/FilterMenuItem";
import FilterMenuPanel from "@/components/filters/FilterMenuPanel";
import { SORT_BY_OPTIONS, SORT_ORDER_OPTIONS } from "../utils/documentFormatters";
import type { DocumentSortBy, DocumentSortOrder } from "../types";

export default function DocumentsSortDropdown({
  sortBy,
  sortOrder,
  onSortByChange,
  onSortOrderChange,
  buttonClassName,
}: {
  sortBy: DocumentSortBy;
  sortOrder: DocumentSortOrder;
  onSortByChange: (value: DocumentSortBy) => void;
  onSortOrderChange: (value: DocumentSortOrder) => void;
  buttonClassName?: string;
}) {
  const isActive = sortBy !== "date_created" || sortOrder !== "newest";
  const valueLabel =
    sortBy === "listing"
      ? "Shipments"
      : sortOrder === "oldest"
        ? "Oldest"
        : "Sort";

  return (
    <FilterDropdown
      label="Sort"
      valueLabel={valueLabel}
      active={isActive}
      buttonClassName={buttonClassName}
      menuWidth={144}
    >
      {(close) => (
        <FilterMenuPanel width={144}>
          <FilterMenuLabel>Sort By</FilterMenuLabel>
          {SORT_BY_OPTIONS.map((option) => (
            <FilterMenuItem
              key={option.value}
              active={
                option.value === "listing"
                  ? sortBy === "listing"
                  : sortBy === "date_created" && sortOrder !== "oldest"
              }
              onClick={() => {
                onSortByChange(option.value);
                if (option.value === "date_created") {
                  onSortOrderChange("newest");
                }
                if (option.value === "listing") close();
              }}
            >
              {option.label}
            </FilterMenuItem>
          ))}
          {sortBy !== "listing" ? (
            <>
              <FilterMenuDivider />
              <FilterMenuLabel>Order</FilterMenuLabel>
              {SORT_ORDER_OPTIONS.filter((option) => option.value === "oldest").map((option) => (
                <FilterMenuItem
                  key={option.value}
                  active={sortOrder === option.value}
                  onClick={() => {
                    onSortByChange("date_created");
                    onSortOrderChange(option.value);
                    close();
                  }}
                >
                  {option.label}
                </FilterMenuItem>
              ))}
            </>
          ) : null}
        </FilterMenuPanel>
      )}
    </FilterDropdown>
  );
}
